module.exports = __webpack_public_path__ + "static/media/logo.a1e18b5d.svg";